import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../store/appStore';
import { Input } from '../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { CourseCard } from '../components/Cards';

export default function CoursesPage() {
  const { t, i18n } = useTranslation();
  const { courses, fetchCourses } = useAppStore();
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ city: '', course_type: 'all', is_online: 'all' });

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const params = { ...filters };
      if (params.course_type === 'all') delete params.course_type;
      if (params.is_online === 'true') params.is_online = true;
      else if (params.is_online === 'false') params.is_online = false;
      else delete params.is_online;
      await fetchCourses(params);
      setLoading(false);
    };
    load();
  }, [fetchCourses, filters]);

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 animate-fade-in" data-testid="courses-page">
      <h1 className="font-serif text-4xl font-bold text-primary mb-8">{t('course.title')}</h1>
      
      <div className="flex flex-wrap gap-4 mb-8">
        <Input placeholder={t('common.location')} value={filters.city} onChange={(e) => setFilters({ ...filters, city: e.target.value })} className="w-48" />
        <Select value={filters.course_type} onValueChange={(v) => setFilters({ ...filters, course_type: v })}>
          <SelectTrigger className="w-48"><SelectValue placeholder={t('course.type')} /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos</SelectItem>
            <SelectItem value="retreat">{t('course.types.retreat')}</SelectItem>
            <SelectItem value="workshop">{t('course.types.workshop')}</SelectItem>
            <SelectItem value="training">{t('course.types.training')}</SelectItem>
            <SelectItem value="online">{t('course.types.online')}</SelectItem>
          </SelectContent>
        </Select>
        <Select value={filters.is_online} onValueChange={(v) => setFilters({ ...filters, is_online: v })}>
          <SelectTrigger className="w-32"><SelectValue placeholder="Modalidad" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos</SelectItem>
            <SelectItem value="true">Online</SelectItem>
            <SelectItem value="false">Presencial</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {loading ? (
        <div className="text-center py-12"><p className="text-secondary">{t('common.loading')}</p></div>
      ) : courses.length === 0 ? (
        <div className="text-center py-12"><p className="text-secondary">{t('common.noResults')}</p></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((course) => (
            <CourseCard key={course.id} course={course} language={i18n.language} />
          ))}
        </div>
      )}
    </div>
  );
}
